import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../images/token-img.png'


const _hoisted_1 = {
  class: "cm-align-center",
  style: {"flex-direction":"column"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "150",
  height: "150",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1767514763595",
  class: "icon cm-ui-mr5",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5981",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M511.893356 1023.978671a511.893356 511.893356 0 1 1 511.893355-511.893355 511.893356 511.893356 0 0 1-511.893355 511.893355z m123.387627-767.840033a147.93718 147.93718 0 0 0-77.338554 21.030285 135.395793 135.395793 0 0 0-71.067861 117.735472v237.731806a80.004666 80.004666 0 0 1-42.65778 68.828327 102.613289 102.613289 0 0 1-50.037575 13.07461 88.002999 88.002999 0 0 1-92.695355-81.902937 72.262279 72.262279 0 0 1 10.813747-38.669277 93.676484 93.676484 0 0 1 54.580629-39.821038 15.996667 15.996667 0 0 1 6.270693-1.130431 28.43141 28.43141 0 1 0 0-56.86282 86.488648 86.488648 0 0 0-23.888356 3.967173 148.299771 148.299771 0 0 0-85.31556 64.285274 133.13493 133.13493 0 0 0-19.345303 68.252448 144.4819 144.4819 0 0 0 149.558176 138.787086 156.404749 156.404749 0 0 0 77.914434-20.475735 135.43845 135.43845 0 0 0 71.067861-117.735471V394.947053a80.025995 80.025995 0 0 1 42.65778-68.828328 102.78392 102.78392 0 0 1 50.037575-13.074609 87.832368 87.832368 0 0 1 92.119475 81.902937 72.262279 72.262279 0 0 1-10.813747 38.669277 89.154759 89.154759 0 0 1-54.580629 39.821037 15.975338 15.975338 0 0 1-6.249365 1.130431 28.452739 28.452739 0 0 0 0 56.88415 83.587919 83.587919 0 0 0 23.888357-3.988503 148.342429 148.342429 0 0 0 85.315559-64.263945 133.433535 133.433535 0 0 0 19.323975-68.252447 144.460571 144.460571 0 0 0-149.66482-138.765757z",
    fill: "var(--el-color-primary)",
    "p-id": "5982"
  })
], -1)

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'token-code',
  props: {
  tooltipOpt:{
    type:Object,
    default:() => ({})
  },
  codeStyle: {
    type: String,
  }
},
  setup(__props) {

const { t } = useI18n()


//点击查看教程
const goToWord = () => {
  window.open('/word-remote', '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({ effect: "light" }, __props.tooltipOpt), {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_button, {
          type: "text",
          class: "",
          size: "mini",
          onClick: goToWord
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('remoteAuth.clickViewTutorial')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", {
          class: "cm-align-center",
          style: _normalizeStyle(__props.codeStyle)
        }, [
          _hoisted_3,
          _createVNode(_component_el_button, {
            type: "text",
            style: {"font-size":"14px"},
            size: "mini"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('remoteAuth.tokenAppCode')), 1)
            ]),
            _: 1
          })
        ], 4)
      ])
    ]),
    _: 3
  }, 16))
}
}

})